




























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

import { STORE_KEY, store } from "./_store";

import AgentForm from "../AgentForm/AgentForm.vue";
import DocumentFeed from "@/components/Details/DocumentFeed/DocumentFeed.vue";
import AgentDealList from "./AgentDealList/AgentDealList.vue";
import AgentClientList from "./AgentClientList/AgentClientList.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "document",
      "meta"
    ])
  },
  components: {
    AgentForm,
    DocumentFeed,
    AgentDealList,
    AgentClientList
  }
})
export default class AgentDetails extends Vue {
  @Prop() params!: any;

  document!: any;

  public TAB_VIEW_DETAILS = 0;
  public TAB_VIEW_FORM = 1;

  hActiveTab: number | null = null;

  get activeTab() {
    return this.hActiveTab
      ? this.hActiveTab
      : this.isNew
      ? this.TAB_VIEW_FORM
      : this.TAB_VIEW_DETAILS;
  }

  set activeTab(value: number) {
    this.hActiveTab = value;
  }

  public activeDetailTab = 0;

  get config() {
    return this.params || this.$route.params;
  }

  get isModal() {
    return this.params;
  }

  get isNew() {
    return this.config.id == "new";
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    this.activeDetailTab = this.$route.query.tab
      ? parseInt(this.$route.query.tab as any)
      : 0;
  }

  public toArchive(agentId: any) {
    this.$buefy.dialog.confirm({
      message: "Отправить агента в архив?",
      confirmText: "В архив",
      cancelText: "Отмена",
      type: "is-danger",
      onConfirm: () => {
        this.$store.dispatch(`${STORE_KEY}/toArchive`, agentId).then(() => {
          this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
        });
      }
    });
  }

  public toUnarchive(agentId: any) {
    this.$buefy.dialog.confirm({
      message: "Восстановить агента из архива?",
      confirmText: "Восстановить",
      cancelText: "Отмена",
      type: "is-danger",
      onConfirm: () => {
        this.$store.dispatch(`${STORE_KEY}/toUnarchive`, agentId).then(() => {
          this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
        });
      }
    });
  }

  onTab(tab: number) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        // @ts-ignore
        tab
      }
    });
  }

  onNeedDataReload(documentId: string) {
    if (!this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...this.config,
        silence: true
      });
    } else if (this.config.from === "list") {
      this.$emit("agent-saved", documentId);
      this.$emit("close");
    } else {
      this.$router.replace({
        name: "agent-details",
        params: {
          id: documentId
        }
      });
    }
  }

  public goBack() {
    if (this.isModal && this.config.from === "list") {
      this.$emit("close");
    } else if (!this.params) {
      this.$router.push({ name: "agents-list" });
    } else {
      this.$router.back();
      this.$emit("close");
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
